import "../../Styles/introction.css";
import { connect } from "react-redux";
import Footer from "../../Components/Footer/Footer";

const Introduction = ({ isTamil }) => {
  return (
    <div
      style={{
        background: `linear-gradient(90deg, rgba(230, 250, 250, 0.96) 0%, rgba(230, 250, 250, 0.92) 57%, rgba(230, 250, 250, 1) 55%, rgba(230, 250, 250, 0.76) 100%, rgba(230, 250, 250, 0.45) 100%)`,
      }}
      className={`${"pp"}`}
    >
      <h1 className="introduction_1">முன்னுரை</h1>
      <div className="card">
        <div className="card-header words_introduction">சொல்</div>
        <div className="card-content">
          ஒன்று அல்லது அதற்கு மேற்பட்ட எழுத்துக்கள் இணைந்து பொருள் தருவது சொல்
          ஆகும். மொழிக்கு அடிப்படை அலகாகச் சொல் முதலில் இடம்பெற்றுள்ளது.
          பேசுவதற்கும் எழுதுவதற்கும் சொற்கள் இன்றியமையாதவையாக அமைகின்றன.
        </div>
      </div>
      <div className="card">
        <div className="card-header_3 english_words">ஆங்கில சொல்</div>
        <div className="card-content">
          தமிழ்ச்சொல்லுக்கு இணையான ஆங்கிலச் சொல் அல்லது அதன் விளக்கம் இங்குத்
          தரப்பட்டுள்ளது.
        </div>
      </div>

      <div className="card">
        <div className="card-header picture_new">படம்</div>
        <div className="card-content">
          சில தமிழ்ச்சொற்களுக்கான படங்கள் இங்கு இணைக்கப்பட்டுள்ளன.
        </div>
      </div>
      <div className="card">
        <div className="card-header_3 volume">ஒலி</div>
        <div className="card-content">
          தமிழ்ச்சொல்லின் சரியான உச்சரிப்பு, ஒலிக்கோப்பாக இங்குத்
          தரப்பட்டுள்ளது.
        </div>
      </div>

      <div></div>

      <div className="card">
        <div className="card-header Noun_01"> இலக்கணம்</div>
        <h2 className="example_1">1. பெயர்ச்சொல்:</h2>
        <div className="card-content_1">
          <span className="space_01"></span>
          பெயரைக் குறிக்கும் சொல்லைப் பெயர்ச்சொல் என்கிறோம். இது நபர், பொருள்,
          இடம், காலம், குணம், தொழில் ஆகியவற்றைக் குறிக்கப் பயன்படுகின்றது.
        </div>
        <h2 className="example_1 example_2 ">உதாரணம்:</h2>
        <div className="card-content space_adjustment">
          அவன், சிங்கப்பூர், மாதம், கண், பசுமை, படித்தல், நீந்துதல்.
        </div>
        <h2 className="example_1">2. வினைச்சொல்:</h2>
        <div className="card-content_1">
          <span className="space_01"></span> ஒரு செயலையோ அல்லது ஒரு நிகழ்வையோ
          உணர்த்தும் சொல் வினைச்சொல் எனப்படும்.
        </div>
        <h2 className="example_1 example_2">உதாரணம்:</h2>
        <div className="card-content space_adjustment">
          எழுது, ஓடினான், படி, நீந்து, ஆடு, வரைந்தான்.
        </div>
        <h2 className="example_1">3. இடைச்சொல்:</h2>
        <div className="card-content_1">
          {" "}
          <span className="space_01"></span>
          இடைச்சொற்கள் என்பது தனித்து நின்று பொருள் தராது. பெயர்ச்சொல்லையோ
          அல்லது வினைச்சொல்லையோ சார்ந்து வரும்.
        </div>
        <h2 className="example_1 example_2">உதாரணம்:</h2>
        <div className="card-content space_adjustment">
          ஐ, ஆல், கு, இன், அது, கண், உம், ஆம், இல்லை, அல்ல.
        </div>
        <h2 className="example_1 ">4. பெயரடை:</h2>
        <div className="card-content_1">
          <span className="space_01"></span> பெயர்ச்சொல்லின் பண்பு, தரம், நிலை
          அல்லது எண்ணிக்கையை விளக்க உதவும் சொல் பெயரடையாகும். இது
          பெயர்ச்சொல்லுக்கு முன்னதாகவோ, பின்னதாகவோ பயன்படுத்தப்படும்.
        </div>
        <h2 className="example_1 example_2">உதாரணம்:</h2>
        <div className="card-content space_adjustment">
          நல்ல பையன், பெரிய மாளிகை, ஐந்து மாணவர்கள்.
        </div>
        <h2 className="example_1">5. வினையடை:</h2>
        <div className="card-content_1">
          <span className="space_01"></span> வினையடை என்பது, வினைச்சொல்லின்
          செயலை மேலும் விளக்கப் பயன்படுகிறது. அது, அந்தச் செயல் எவ்வாறு
          நிகழ்கிறது, எந்த அளவுக்கு நிகழ்கிறது, எவ்வளவு காலம் நிகழ்கிறது போன்ற
          விளக்கங்களைத் தருகிறது.
        </div>
        <h2 className="example_1 example_2">உதாரணம்:</h2>
        <div className="card-content space_adjustment">
          வேகமாக நடந்தாள், நேற்று நிகழ்ந்தது, அழகாக சிரித்தாள்.
        </div>
      </div>

      <div className="card">
        <div className="card-header Basic_material"> அடிப்படைப் பொருண்மை</div>
        <div className="card-content">
          தமிழ்ச் சொல்லுக்கான பொருள் இடம்பெற்றுள்ளது.
        </div>
      </div>
      <div className="card">
        <div className="card-header_11  example_01"> எடுத்துக்காட்டு</div>
        <div className="card-content">
          தமிழ்ச்சொல்லைப் பயன்படுத்தி அமைக்கப்பட்ட வாக்கியம் இடம்பெற்றுள்ளது.
        </div>
      </div>

      <div className="card">
        <div className="card-header_6 Adjective_12">இணைச்சொல்</div>
        <div className="card-content_1 card-content_001">
          இணைச்சொல் என்பது ஒரே பொருள் கொண்ட வேறுபட்ட சொற்களைக் குறிக்கின்றன.
        </div>
        <h2 className="example_1 example_001">உதாரணம்:</h2>
        <div className=" card-content_100  elephant">
          யானை - களிறு, கைம்மா, வேழம்.
        </div>
        <div className="card-content ">
          யானை என்பதைக் குறிக்க களிறு, கைம்மா, வேழம் போன்ற பல்வேறு சொற்கள்
          பயன்படுத்தப்படுகின்றன.
        </div>
      </div>
      <div className="card">
        <div className="card-header Adjective_05">எதிர்ச்சொல்</div>
        <div className="card-content_1 antonyms">
          எதிர்ச்சொல் என்பது ஒரு சொல்லுக்கு நேர் எதிரான பொருள் தரும் சொல்லைக்
          குறிக்கின்றது.
        </div>
        <h2 className="example_1 example_001">உதாரணம்:</h2>
        <div className="card-content_100 elephant">இன்பம் X துன்பம்</div>
        <div className="card-content">
          இன்பம் என்பது மகிழ்ச்சியையும், துன்பம் என்பது துக்கத்தையும்
          குறிக்கின்றது. இவை இரண்டும் ஒன்றுக்கொன்று எதிரான கருத்துக்களைக் கொண்ட
          சொற்களாக அமைகின்றன.
        </div>
      </div>

      <div className="card">
        <div className="card-header_7 Adjective_02">ஒலி வேறுபாட்டுச் சொல்</div>
        <div className="card-content card_content_31">
          ஒலி வேறுபாடு என்பது ஒலிப்பு ஒன்றுபோல இருந்தாலும், எழுத்து வடிவத்திலும்
          பொருளிலும் வேறுபடும் சொற்களைக் குறிக்கும். இதனை மயங்கொலி என்கிறோம்.
          மயங்கொலி ண, ன, ந, ல, ள, ழ, ர, ற ஆகிய எட்டு எழுத்த்துக்களால் ஏற்படும்
          மாற்றங்களை மட்டுமே குறிக்கின்றன.
        </div>
        <h2 className="example_1 example_001">உதாரணம்:</h2>

        <h2 className="intructtion_5">"ண, ன, ந - வேறுபாடு"</h2>
        <p className="introduction_2">மனம் - உள்ளம்</p>
        <p className="introduction_2">மணம் - வாசனை</p>
        <p className="introduction_2">நண்பு – அன்பு</p>
        <p className="introduction_2">நன்பு - நன்மை</p>
        <h2 className="intructtion_5">"ல, ள,ழ - வேறுபாடு"</h2>
        <p className="introduction_2">
          கலை – ஓவியம், சிற்பம், இசை போன்றவற்றைக் குறிக்கும் பொதுவான சொல்
        </p>
        <p className="introduction_2">
          {" "}
          களை- பயிர்களின் இடையில் வளரும் தேவையற்ற புல், பூண்டு
        </p>
        <p className="introduction_2">கழை - மூங்கில்</p>
        <h2 className="intructtion_5">"ர,ற - வேறுபாடு"</h2>
        <p className="introduction_2">மரம் - தாவரம்</p>

        <p className="introduction_2 homephones_last">மறம் - வீரம்</p>
      </div>
      <div className="card">
        <div className="card-header Legacy_02">அயற்சொல்</div>
        <div className="card-content card_content_31">
          வேற்றுமொழியில் இருந்து தமிழ் மொழியில் கலந்த சொற்களை அயற்சொற்கள்
          என்கிறோம். இவை தமிழ் மொழியின் ஒலிப்புமுறைக்குப் புறம்பான ஒலிகளைக்
          கொண்டுள்ளன.
        </div>
        <div className="card-content card_content_31">
          சமஸ்கிருதம், ஆங்கிலம், அரபு, பாரசீகம், போர்ச்சுகீசியம், உருது,
          தெலுங்கு, கன்னடம், மலையாளம் என இன்னும் பல மொழிகளிலிருந்து சொற்கள்
          தமிழ் மொழியில் கலந்துள்ளன.
        </div>
        <h2 className="example_1 example_001">உதாரணம்:</h2>
        <p className="   introduction_002">அகராதி - சமஸ்கிருதம் </p>
        <p className=" introduction_002"> முகாம் - அரபு </p>
        <p className=" introduction_002">சுமார் - பாரசீகம் </p>

        <p className=" introduction_002">சாவி - போர்ச்சுகீசியம் </p>
        <p className=" loan_word_last introduction_002"> சீட்டு - உருது </p>
      </div>
      <div className="card">
        <div className="card-header_9 Articulate">கலைச்சொல் விளக்கம்</div>
        <div className="card-content_department card_content_031">
          கலைச்சொல் என்பது ஒரு குறிப்பிட்ட துறையில் பயன்படுத்தப்படும் சிறப்பு
          கொண்ட சொற்களைக் குறிக்கிறது. அத்துறையில் உள்ளவர்களுக்கு மட்டுமே
          எளிதில் புரிந்துகொள்ளக்கூடியதாக இருக்கும். சில நேரங்களில், பிற
          துறையினருக்கு அல்லது பொதுமக்களுக்கு இச்சொற்கள் புரியாமல் போகலாம்.
          இத்தகைய சொற்களை விளக்குவதற்காகக் கலைச்சொல் விளக்கம் பயன்படுகிறது.
          அறிவியல், மருத்துவம், தொழில்நுட்பம், சமூகவியல், கலை, சட்டம், கல்வி,
          வணிகம், பொருளாதாரம் மற்றும் வேளாண்மை போன்ற பல்வேறு துறைகளில் உள்ள
          கலைச்சொற்கள் தொகுக்கப்பட்டுள்ளன. இந்தப் பகுதியில், கலைச்சொல்லுக்கான
          விளக்கமும் அது எந்தெந்தத் துறைகளில் முக்கியமாகப் பயன்படுத்தப்படுகின்றன
          என்பதையும் குறிப்பிட்டுள்ளோம்.
        </div>
        {/* <div className="card-content card_content_031">
          அறிவியல், மருத்துவம், தொழில்நுட்பம், சமூக அறிவியல், கலை, சட்டம்,
          கல்வி, மற்றும் விவசாயம் போன்ற பல்வேறு துறைகளில் உள்ள கலைச்சொற்கள்
          தொகுக்கப்பட்டிருக்கின்றது.
        </div> */}
        <h2 className="example_1 example_001 one_line_spacing">உதாரணம்:</h2>
        <h2 className="example_1 example_001 ">
          கலைச்சொல்: <span className="medinice_new new_marabiyal">மரபியல்</span>
        </h2>
        <h2 className="example_1 example_001 ">விளக்கம்:</h2>

        <div className="card-content_department card_content_031 ">
          உயிரினங்களின் மரபணுக்கள், மரபுப்பண்புகள் மற்றும் பாரம்பரியம்
          (heredity) பற்றி ஆய்வு செய்கிறது. ஒரு தலைமுறையிலிருந்து அடுத்த
          தலைமுறைக்கு மரபுப் பண்புகள் எவ்வாறு கடத்தப்படுகின்றன, மரபணுக்களில்
          ஏற்படும் மாற்றங்கள் (mutations) மற்றும் அவற்றின் விளைவுகள் ஆகியவற்றை
          இது விளக்குகிறது.
        </div>
        {/* <h2 className="example_new_desing example_001">துறை:<span>மருத்துவம், உயிரியல்</span> </h2> */}
        <div className="main_department">
          <h1 className="example_new_desing example_001">
            {" "}
            துறை:{" "}
            <span className="medinice_new new_marabiyal">
              மருத்துவம், உயிரியல்
            </span>
          </h1>
        </div>
      </div>
      <h1 className="grammar">உருவகமொழி</h1>
      <div className="card main_department">
        <div className="card-header Legacy">மரபுத்தொடர்</div>
        <div className="card-content card_content_31">
          மரபுத்தொடர் என்பது பல சொற்கள் சேர்ந்து ஒரு குறிப்பிட்ட பொருளை
          உணர்த்தும் சொற்றொடர் ஆகும். இது சொற்களின் நேரடி பொருளைத் தராமல், அதனை
          விட வேறுபட்ட ஒரு பொருளைத் தரும். இது தலைமுறை தலைமுறையாக, மரபு சார்ந்து
          மாறாமல் பயன்படுத்தப்பட்டு வருகின்றது.
        </div>
        <h2 className="example_1 example_001 one_line_spacing">உதாரணம்:</h2>
        <div className="card-content scince_01">அகராதி பிடித்தவன்</div>
        <h2 className="example_1 example_001 direact_font_control">
          1. நேரடிப் பொருள் (சொற்பொருள்):
        </h2>
        <p className="card-content_idioms">
          <span className="space_01"></span>"அகராதி பிடித்தவன்" என்ற தொடரை
          வார்த்தை வாரியாகப் பிரித்துப் பார்த்தால், "அகராதியைக் கையில்
          வைத்திருப்பவன்" அல்லது "அகராதியை விரும்புபவன்" என்று பொருள் வரும். இது
          அதன் நேரடிப் பொருள்.
        </p>
        <h2 className="example_1 example_001 direact_font_control">
          2. மரபுப் பொருள் (குறிப்புப் பொருள்):
        </h2>
        <p className="card-content_idioms">
          <span className="space_01"></span> நாம் பயன்படுத்தும்போது இந்த நேரடிப்
          பொருளில் பயன்படுத்துவதில்லை. மாறாக, "திமிர் பிடித்தவன், பிடிவாத குணம்
          கொண்டவன், வீண்வாதம் செய்பவன்" என்ற முற்றிலும் மாறுபட்ட ஒரு குணத்தைக்
          குறிக்கப் பயன்படுத்துகிறோம்.
        </p>
      </div>

      <div className="card main_department">
        <div className="card-header_8 Legacy_01 ">உவமைத்தொடர்</div>
        <div className="card-content card_content_31">
          உவமைத்தொடர் என்பது ஒரு பொருளை அல்லது நிகழ்வை வேறொரு பொருளுடனோ அல்லது
          நிகழ்வுடனோ ஒப்புமைப்படுத்தி, அதன் தன்மையை விளக்கும் சொற்றொடர் ஆகும்.
          மேலும், உவமைத்தொடர்களில் போல், போல ஆகிய உருபுகள் கட்டாயம் இடம்பெறும்.
        </div>
        <h2 className="example_1 example_001 one_line_spacing">உதாரணம்:</h2>
        <div className="card-content scince_01">அச்சாணியற்ற தேர் போல</div>
        <div className="card-content card_content_31">
          <span className="space_01"></span> தேரின் சக்கரங்கள் கழன்றுவிடாமல்
          இருக்கவும், தேர் சீராக ஓடவும் அச்சாணி மிக முக்கியம். அச்சாணி
          இல்லையென்றால், தேர் நிலைதடுமாறி, ஓடமுடியாமல் சிதைந்துவிடும். அதுபோல,
          ஒரு அமைப்புக்கு அல்லது ஒரு செயலுக்கு முதன்மையான ஒரு தலைவர், வழிகாட்டி
          அல்லது ஆதரவு இல்லாததால் ஏற்படும் நிலைகுலைவையும், தடுமாற்றத்தையும்
          இத்தொடர் குறிக்கிறது.
        </div>
      </div>
      <div className="card slider_last_01 new_legacy_last main_department">
        <div className="card-header Legacy_02">இணைமொழி</div>
        <div className="card-content card_content_31">
          இரண்டு சொற்கள் இணைந்து, ஓசை நயத்துடன் ஒரு புதிய அல்லது விரிவான
          பொருளைத் தருவதே இணைமொழி ஆகும். இது ஒரு கருத்தை அழுத்தம்
          திருத்தமாகவும், சுருக்கமாகவும், அழகாகவும் வெளிப்படுத்தப் பயன்படுகிறது.
        </div>
        <h2 className="example_1 example_001 one_line_spacing">உதாரணம்:</h2>
        <div className="card-content scince_01">அகட விகடம்</div>
        <div className="card-content card_content_31">
          <span className="space_01"></span> "அகடவிகடம்" என்பது 'அகட', 'விகடம்'
          என இரண்டு சொற்கள் இணைந்து, சிறப்பான ஓசை நயத்துடன் காணப்படுகிறது.
          இத்தொடர் தனிப் பொருள்களை விடுத்து, "வம்புப் பேச்சு" என்ற ஒரு
          ஒருங்கிணைந்த புதிய பொருளைத் தருகிறது. இந்த இரட்டைச் சொல் அமைப்பு, ஓசை
          நயம், மற்றும் ஒருங்கிணைந்த பொருளே இது இணைமொழி எனப்படக் காரணம்.
        </div>
      </div>
      <Footer />
    </div>
  );
};

// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});

// Connect component to Redux store
export default connect(mapStateToProps)(Introduction);
